import { useEffect } from 'react';
import { unnecessaryFields, unnecessaryModals } from '../../../../../constants/service-data';
import { useUser } from '../../../../../redux/reducer/user';
import useServiceData from '../../../../../hooks/useServiceData';

export default function useClearServiceDataModals() {
  const { profile } = useUser();
  const { get, save, remove } = useServiceData();

  useEffect(() => {
    if (typeof profile?.score !== 'number') return;

    (async () => {
      await Promise.all(unnecessaryFields.map((field) => (get(field) ? remove(field) : Promise.resolve())));

      const modalsData = get('modalsData') ?? {};

      const filteredModalsData = {};

      for (const key in modalsData) {
        const isNecessaryKey = !unnecessaryModals?.some((id) => key.includes(id));

        const isPrevPassedLevel =
          key.startsWith('passedLevelModal') && Number(key.replace('passedLevelModal', '')) > profile?.score;

        if (isNecessaryKey && !isPrevPassedLevel) filteredModalsData[key] = modalsData[key];
      }

      if (Object.values(filteredModalsData)?.length) save('modalsData', filteredModalsData);
    })();
  }, [profile?.score]);
}
